import { render, staticRenderFns } from "./elArchives.vue?vue&type=template&id=46f6475e&scoped=true&"
import script from "./elArchives.vue?vue&type=script&lang=js&"
export * from "./elArchives.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f6475e",
  null
  
)

export default component.exports